
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import $ from 'jquery';
import tabbar from '@/components/tabbar'
export default {
components: {
tabbar,
TabbarItem,
Group,
Cell
},
data () {
return {
refresh:false,
animate: false,
marqueeList: [{tipTitle:"正在加载...",tipForm:1}]
}
},
created() {
let loginData = localStorage.getItem('loginData');
if (loginData) {
return;
} else {
this.$router.push('/');
}

},
mounted(){

this.findOwner()
},
methods:{
gettipList(){
let that=this;
this.BM.JQajax({
url:this._Api.gettipList,
method:"GET",
contentT:'application/x-www-form-urlencoded',
success: function(data) {
if(data.data){
that.marqueeList=data.data;
if(data.data.length>1){
setInterval(that.showMarquee, 4000);
}
}else{
that.animate = false;
that.marqueeList=[{tipTitle:"暂无提醒",tipForm:1}]
}
},
error:function(data){
},
unAuth:function(){
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});
}
})
},
showMarquee() {
this.animate = true;
setTimeout(()=>{
this.marqueeList.push(this.marqueeList[0]);
this.marqueeList.shift();
this.animate = false;
},500)
},
refreshToken(){
const key = 'webApp:webApp'
let authKey = "";
authKey = 'Basic '+Base64.encode(key);
let that=this;
let loginData=JSON.parse(localStorage.getItem("loginData"));
let refresh=loginData.refresh_token;
this.BM.JQajax({
url:that._Api.refreshToken,
method:"POST",
token:authKey,
data:{
"grant_type":"refresh_token",
refresh_token:refresh,
},
success: function(data) {
},
error:function(data){
}
})
},
findOwner(){
let that=this;
let loginData=JSON.parse(localStorage.getItem("loginData"));
let token=loginData.token_type+" "+loginData.access_token;
this.BM.JQajax({
url:that._Api.ownerData,
method:"GET",
token:token,
success: function(data) {
if(data.data && data.data.ownerId){
localStorage.setItem('ownerData', JSON.stringify(data.data));
}else{
localStorage.removeItem('ownerData');
}
},
error:function(data){

localStorage.removeItem('ownerData');
},
unAuth:function(){
that.$vux.alert.show({
title: '验证失败',
content: "请重新登录",
})
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/home.vue